import React from "react";
import { Formik, Field, Form } from "formik";
import uuid from "uuid/v4";
import { makeStyles } from "@material-ui/styles";
import validate from "./validate";
import { initialValues } from "./inititalValues";
import { Row } from "../password/UIComponents";
import MuiTextInput from "../../Common/MuiTextInput";
import { Button } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  submit: {
    marginTop: "16px",
    borderTop: `1px solid ${theme.app.borderColor}`,
    padding: "8px 0",
    display: "grid",
    gridTemplateColumns: "1fr auto",
    alignItems: "center",
  },
  formActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& button": {
      marginLeft: "8px",
    },
  },
  button: { color: theme.app.labelColor },
}));

const PasswordForm = (props) => {
  const { handleSubmit, language } = props;
  const classes = useStyles();
  return (
    <Formik
      initialValues={{ ...initialValues, managedPartyId: uuid() }}
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      validate={(values) => validate(values, language)}
      render={(props) => (
        <Form>
          <Row>
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.Account_FirstName.Label}
              name="firstname"
              placeholder={language.Account_FirstName.Placeholder}
              type="text"
              required={true}
              autocomplete="given-name"
            />
          </Row>
          <Row>
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.Account_LastName.Label}
              name="lastname"
              placeholder={language.Account_LastName.Placeholder}
              type="text"
              required={true}
              autocomplete="family-name"
            />
          </Row>
          <Row>
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.Account_CivicRegistrationNumber.Label}
              name="civicRegistrationNumber"
              placeholder={language.Account_CivicRegistrationNumber.Placeholder}
              type="text"
              required={true}
            />
          </Row>
          <div className={classes.submit}>
            <div>
              <Button
                onClick={() => window.history.back()}
                className={classes.button}
                variant="subtle"
                color="dark"
              >
                {language.Back}
              </Button>
            </div>
            <div className={classes.formActions}>
              <Button
                disabled={!props.isValid || props.isSubmitting}
                type="submit"
                className="register-managed__submit-button primaryButton"
              >
                {language.Save}
              </Button>
            </div>
          </div>
        </Form>
      )}
    />
  );
};

export default PasswordForm;
